import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { strings } from "../strings";
import {
  ADMIN_ROLES,
  ARCHIVE_ROLES,
  AUDIT_ROLES,
  DATA_QUALITY_ROLES,
  DECKS_ROLES,
  IMPORT_ROLES,
  PRODUCTS_ROLES,
  PROJECTS_ROLES,
  ROADMAP_ROLES,
} from "./screenAccess";
import "./appLayout.css";

// Role sets come from ./screenAccess (see that file's header for the owner ruling this nav
// enforces and the BRD section 4 conflict it knowingly overrides) so a tab here can never drift
// out of lockstep with its route's RequireRole roles in App.tsx.
const NAV_ITEMS: ReadonlyArray<{ to: string; label: string; roles: readonly string[] }> = [
  { to: "/roadmap", label: strings.nav.roadmap, roles: ROADMAP_ROLES },
  { to: "/projects", label: strings.nav.projects, roles: PROJECTS_ROLES },
  { to: "/products", label: strings.nav.products, roles: PRODUCTS_ROLES },
  { to: "/data-quality", label: strings.nav.dataQuality, roles: DATA_QUALITY_ROLES },
  { to: "/decks", label: strings.nav.decks, roles: DECKS_ROLES },
  { to: "/archive", label: strings.nav.archive, roles: ARCHIVE_ROLES },
  { to: "/import", label: strings.nav.import, roles: IMPORT_ROLES },
  { to: "/admin", label: strings.nav.admin, roles: ADMIN_ROLES },
  { to: "/audit", label: strings.nav.audit, roles: AUDIT_ROLES },
];

/** The authenticated shell: Evergreen-branded header, role-filtered nav, and a user menu. */
export function AppLayout() {
  const { caller, logout, hasRole } = useAuth();

  return (
    <div className="eg-shell">
      <header className="eg-shell__header">
        <span className="eg-shell__brand">{strings.appName}</span>
        <nav aria-label={strings.aria.primaryNav}>
          <ul className="eg-shell__nav">
            {NAV_ITEMS.filter((item) => hasRole(...item.roles)).map((item) => (
              <li key={item.to}>
                <NavLink to={item.to}>{item.label}</NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="eg-shell__user">
          {caller && (
            <>
              <span>{caller.displayName}</span>
              <span className="eg-shell__role">{caller.role}</span>
              <button type="button" onClick={logout}>
                {strings.auth.signOut}
              </button>
            </>
          )}
        </div>
      </header>
      <main className="eg-shell__content">
        <Outlet />
      </main>
    </div>
  );
}
